import React from 'react'
import { useSelector } from 'react-redux'
import { getSelectedTopic } from 'reduxes/slices/topics/selectors'

import { Tag } from 'primitives/tag'
import { cn } from 'util/cn'

export default function OwnerBadge({
  handle,
  className,
  ...props
}: { handle: string } & React.HTMLAttributes<HTMLDivElement>) {
  const topic = useSelector<any, any>(getSelectedTopic)
  return handle === topic?.created_by_handle ? (
    <Tag className={cn('owner-badge', className)} {...props}>
      OWNER
    </Tag>
  ) : null
}
